import React from "react";
import SmallPanel from "../SmallPanel/SmallPanel.js";

const LargePanelOverview = ({ key, delta }) => {
  return <SmallPanel key={key} delta={delta} />;
};

export default LargePanelOverview;
